import { rideStateLabel } from '@/lib/ride-format';
import { Icon } from '@/components/ui/icon';

const FLOW = [
  'RIDE_CONFIRMED',
  'RIDE_ASSIGNED',
  'RIDE_ENROUTE_PICKUP',
  'RIDE_ARRIVED_PICKUP',
  'RIDE_STARTED',
  'RIDE_ENDED',
];

export function RideStateTimeline({ rideState }: { rideState?: string }) {
  if (rideState === 'RIDE_CANCELLED') {
    return (
      <div
        className="wb-card wb-card--pad wb-small wb-strong"
        style={{
          color: 'var(--danger)',
          background: 'color-mix(in oklab, var(--danger) 10%, var(--surface))',
          borderColor: 'color-mix(in oklab, var(--danger) 30%, transparent)',
        }}
      >
        This ride was cancelled.
      </div>
    );
  }

  const current = rideState ? FLOW.indexOf(rideState) : 0;

  return (
    <div className="wb-card wb-card--pad">
      <div className="wb-timeline">
        {FLOW.map((s, i) => {
          const done = i < current;
          const active = i === current;
          const last = i === FLOW.length - 1;
          return (
            <div className="wb-tl-row" key={s}>
              <div className="wb-tl-rail">
                <span className={`wb-tl-node ${done ? 'is-done' : active ? 'is-current' : ''}`}>
                  {done && <Icon name="check" size={11} style={{ color: 'var(--on-honey)' }} />}
                </span>
                {!last && <span className={`wb-tl-line ${done ? 'is-done' : ''}`} />}
              </div>
              <div
                className="wb-tl-label"
                style={{
                  color: active || done ? 'var(--ink)' : 'var(--ink-2)',
                  fontWeight: active ? 640 : 500,
                }}
              >
                {rideStateLabel(s)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
